import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Button from '../../../../components/Button';
import Icon, { Icons } from '../../../../components/Icon/Icon';
import { t } from '../../../../lang';
import { appSlice } from '../../../../store/slices';
import { createRootModal } from '../../RootModal';

import AppConfig from '../../../../config';
import './PwaInstallInstruction.scss';

const { productName, pwaInstructions } = AppConfig;

const PwaInstallInstruction = createRootModal(() => {
	const dispatch = useDispatch();

	const closeModal = () => dispatch(appSlice.actions.closeLastModal());

	return (
		<div className='PwaInstallInstruction__body'>
			<img className='PwaInstallInstruction__logo' src={pwaInstructions} alt='instruction' />

			<div className='PwaInstallInstruction__title'>
				{t('Add {productName} to Home Screen', { productName: productName })}
			</div>
			<div className='PwaInstallInstruction__subtitle'>
				1.{' '}
				{t('Tap the {icon} button at the bottom', {
					icon: (
						<Icon className='PwaInstallInstruction__share' type={Icons.ARROW_SQUARE_UP_BOLD} width={24} height={24} />
					),
				})}
			</div>
			<div className='PwaInstallInstruction__subtitle'>
				2.{' '}
				{t('Select {icon} <p>to Home Screen</p>', {
					icon: <Icon type={Icons.PLUS_SQUARE} width={24} height={24} />,
					p: chunk => <p>{chunk}</p>,
				})}
			</div>

			<Button styleType='tertiary' className='PwaInstallInstruction__button' onClick={closeModal}>
				{t('Got it')}
			</Button>
		</div>
	);
});

export default PwaInstallInstruction;
